<div class="header-bar">
    <div class="header-left"><strong>Account Catalog ({{account!.name}})</strong></div>
    <div class="header-center">
        
    </div>
    <div class="header-right">
        <button
            mat-button
            color="lightGreen"
            (click)="saveCatalog()"
            [disabled]="saveDisabled"
        >
        Save Updates
        </button>
    </div>
</div>
<div class="catalog">

    <div class="containers">

        <!-- GENERAL -->
        <div class="container account-details-container">
            <div class="container-header no-bottom-border">
              <div class="text">General</div>
            </div>
            <div class="container-content">

                <mat-form-field appearance="fill">
                    <mat-label>Device Location Timeout</mat-label>
                    <input matInput type="text" [(ngModel)]="account!.catalog.account_app_devices.timeout">
                    <mat-hint>Enter time in seconds</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="fill">
                    <mat-label>Facility Profile Field</mat-label>
                    <input matInput type="text" [(ngModel)]="account!.catalog.profileFacilityPropertyName">
                    <mat-hint>Enter ID of App User Profile Field containing reference to assigned facility</mat-hint>
                </mat-form-field>

            </div>
        </div>
    
        <!-- FIELDS -->
        <div class="container account-details-container fields">
            <div class="container-header no-bottom-border" style="flex-direction: row;">
              <div class="text">User Profile</div>
              <div style="flex: 2; text-align: right; padding-right: 20px;">
                <button color="lightGreen" mat-button class="right" (click)="profileFieldAdd()">Add Field</button>
              </div>
            </div>
            <div class="container-content">
                <app-catalog-field style="margin-top: 5px;" *ngFor="let field of sortedFields(account!.catalog.app_users.profile); index as i" [fields]="account!.catalog.app_users.profile" [field]="field" [account]="account!" [index]="i">
                </app-catalog-field>
            </div>
        </div>
        
        <!-- SIGNALS -->
        <div class="container account-details-container">
            <div class="container-header no-bottom-border">
              <div class="text">Signals</div>
            </div>
            <div class="container-content">

                <mat-form-field appearance="fill">
                    <mat-label>Custom Template Stylesheet</mat-label>
                    <input matInput type="text" [(ngModel)]="account!.catalog.signalTemplates.styles">
                    <mat-hint>Enter file name uploaded to S3 ({{ '{' }}ENV{{ '}' }}/accounts/{{account?.id}}/css)</mat-hint>
                </mat-form-field>

                <mat-checkbox
                    [(ngModel)]="account!.catalog.signals.payload.display_form"
                    color="lightGreen">
                    Enable Payload Editor
                </mat-checkbox>

                <div class="section" [hidden]="!account!.catalog.signals.payload.display_form">
                    <div class="header">
                        <h3 class="left">Lookups</h3>
                        <button color="lightGreen" mat-button class="right" (click)="addLookup()">Add Lookup</button>
                    </div>
                    <div style="border: 1px solid #CCC; border-radius: 10px; padding: 10px; margin-bottom: 10px;" *ngFor="let lookup of account!.catalog.signals.payload.lookups; index as i">
                        <mat-form-field appearance="fill">
                            <mat-label>Name</mat-label>
                            <input matInput type="text" [(ngModel)]="lookup.name">
                        </mat-form-field>
                        
                        <mat-form-field class="wide" appearance="fill">
                            <mat-label>URL</mat-label>
                            <input matInput type="text" [(ngModel)]="lookup.url">
                            <mat-hint>Use {{ '{' }}query{{ '}' }} to pass value searched for</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>HTTP method</mat-label>
                            <mat-select [(value)]="lookup.method">
                                <mat-option value="GET">GET</mat-option>
                                <mat-option value="POST">POST</mat-option>
                            </mat-select>
                        </mat-form-field>
                        
                        <div>
                            <div class="header">
                                <strong class="left">Headers</strong>
                                <button color="lightGreen" mat-button class="right" (click)="addHeader(i)">Add Header</button>
                            </div>
                            <div style="display: flex; flex-direction: row;" *ngFor="let header of lookupHeaders[i]; index as h">
                                <mat-form-field appearance="fill" style="flex: 1; margin-right: 10px;">
                                    <mat-label>Key</mat-label>
                                    <input matInput type="text" [(ngModel)]="header.key" disabled>
                                </mat-form-field>
        
                                <mat-form-field appearance="fill" style="flex: 3;">
                                    <mat-label>Value</mat-label>
                                    <input matInput type="text" [(ngModel)]="header.value" (ngModelChange)="headerValueChange(i, header.key, $event)">
                                </mat-form-field>

                                <button mat-icon-button color="red" aria-label="Remove Header" (click)="headerDelete(i, header.key)">
                                    <mat-icon>delete</mat-icon>
                                </button>

                            </div>
                        </div>

                        <mat-form-field appearance="fill" style="display: flex; flex-direction: row;">
                            <mat-label>Result Label Path</mat-label>
                            <input matInput type="text" [(ngModel)]="lookup.label_path">
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Result Value Path</mat-label>
                            <input matInput type="text" [(ngModel)]="lookup.value_path">
                        </mat-form-field>

                        <div>
                            <button mat-icon-button color="red" aria-label="Remove Lookup" (click)="removeLookup(i)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        

                    </div>
                </div>

            </div>
        </div>

    </div>

    <!-- <pre>{{account!.catalog | json}}</pre> -->

</div>